import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';

import { MgtfeFormState } from './mgtfe-form.state';
import {FordocUserState} from "@app/state/fordoc-user.state";
import {DecisionsState} from "@app/state/decisions.state";
import {MethodologyState} from "@app/state/methodology.state";
import {TitleState} from "@app/state/title.state";

const MODULES = [
  NgxsModule.forFeature([ MgtfeFormState, FordocUserState, DecisionsState, MethodologyState, TitleState ])
];

@NgModule({
  imports: MODULES
})
export class StatesModule {

}
